import React, { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DashboardLayout } from '../../components/layout/DashboardLayout';
import { useSettingsModal } from '../../features/settings/SettingsModalContext';
import { useI18n } from '../../hooks/useI18n';

export const SettingsPage = () => {
  const { t } = useI18n();
  const { openSettings } = useSettingsModal();
  const [searchParams, setSearchParams] = useSearchParams();
  const openedRef = useRef(false);

  useEffect(() => {
    if (openedRef.current) {
      return;
    }
    openedRef.current = true;

    const tabParam = searchParams.get('tab');
    const successParam = searchParams.get('success');
    let tab = 'general';
    if (tabParam === 'wallet' || tabParam === 'personalization' || tabParam === 'general' || tabParam === 'packages' || tabParam === 'profile') {
      tab = tabParam;
    }

    openSettings(tab, { paymentResult: successParam });
    if (tabParam || successParam) {
      setSearchParams({}, { replace: true });
    }
  }, [openSettings, searchParams, setSearchParams]);

  return (
    <DashboardLayout title={t('settings')}>
      <p className="text-sm text-neutral-400">{t('settingsModalHint')}</p>
    </DashboardLayout>
  );
};
